import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import CurrentDateTime from "../CurrentDateTime";
function DetailsScreen() {
  // Access location object to get state
  const location = useLocation();
  const { state } = location;

  const navigate = useNavigate();
  const [errors, setErrors] = useState({});
    // const [bgImageLoaded, setBgImageLoaded] = useState(true);
  
    //   useEffect(() => {
    //   const img = new Image();
    //   img.src = "/assets/images/bookonline-bg1.jpg";
    //   img.onload = () => setBgImageLoaded(true);
    //   img.onerror = () => setBgImageLoaded(false);
    // }, []);

  const handleReschedule = () => {
    navigate("/reschedule", {
      state: { responseData: responseData },
    });
  };

  const handleCancel = () => {
    navigate("/cancel-appointment", {
      state: { responseData: responseData },
    });
  };

  // Check if state exists and contains responseData
  const responseData = state && state.responseData;
  

  // Extract appointment details if responseData exists
  const appointmentDetails = responseData ? responseData : {};
  

  // Format the appointment date and time
  const formattedDate =
    appointmentDetails &&
    new Date(appointmentDetails.scheduledOn).toLocaleDateString();
  const formattedTimeStart =
    appointmentDetails && appointmentDetails.timeStart.slice(0, 5);
  const formattedTimeEnd =
    appointmentDetails && appointmentDetails.timeEnd.slice(0, 5);
  return (
    <>
      <section
        className="d-table w-100"
      //    style={{
      //   // backgroundImage: bgImageLoaded ? `url(/assets/images/bookonline-bg1.jpg)` : "none",
      //   backgroundColor: "gray",
      //   backgroundSize: "cover",
      //   backgroundPosition: "center",
      //   backgroundRepeat: "no-repeat",
      //   minHeight: "100vh",
      //   backgroundAttachment: 'fixed',
      //   paddingTop: '40px',
      // }}
      // >
        style={{
          backgroundImage: `linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)), url(/assets/images/bookonline-bg.jpeg)`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          minHeight: "100vh",
          backgroundAttachment: "fixed",
          paddingTop: "30px",
          position: "relative",
        }}
    >
      {/* LOGO TOP LEFT */}
      <div
        style={{
          position: "absolute",
          top: 5,
          left: 20,
          background: "#ffffff",   // white background only for logo
          padding: "8px 12px",
          borderRadius: "8px",
          zIndex: 99
        }}
      >
        <img
          src="/assets/images/JN_F_Logo.png"
          alt="Logo"
          style={{
            width: "140px",
            height: "50px",
            display: "block"
          }}
        />
      </div>
    
        <CurrentDateTime />
        <div className="container">
        <div className="row justify-content-center mt-5">
        <div className="col-md-5"></div>
        <div className="col-12 col-md-7">
          <div className="card rounded text-center"  style={{backgroundColor:'rgba(255, 255, 255, 0.8)',
                  border:'1px solid #424242',
                  boxShadow:'rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px, rgba(184, 184, 184, 0.5) 2px 2px 32px 2px'
                  }}>
              <h1 className="sub-titlemb-4 mt-5" style={{ color: "#000" }}>Appointment Details</h1>
              {appointmentDetails ? (
                <>
                  <p style={{ color: "#000" }}>
                    Hi, Welcome back{" "}
                    <span style={{ color: "#396cf0" }}>
                      {appointmentDetails.name}
                    </span>
                  </p>
                  <p className="para-desc mx-auto" style={{ color: "#000" }}>
                    Your appointment has been scheduled at our<span style={{ color: "#396cf0" }}>{" "}
                    {appointmentDetails.branchName} </span>branch for the<span style={{ color: "#396cf0" }}>{" "}
                    {appointmentDetails.serviceName}</span> service.
                  </p>
                  <p className="para-desc mx-auto" style={{ color: "#000" }}>
                    Thank you for choosing our services. We look forward to
                    assisting you.
                  </p>
                  <p className="para-desc mx-auto text-bold mb-4" style={{ color: "#396cf0",fontSize:"25px", fontWeight:"bold" }}>
                    <span>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-calendar"
                        viewBox="0 0 16 16"
                      >
                        <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4z" />
                      </svg>
                      &nbsp;{formattedDate}
                    </span>
                    <span>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-clock"
                        viewBox="0 0 16 16"
                      >
                        <path d="M8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71z" />
                        <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16m7-8A7 7 0 1 1 1 8a7 7 0 0 1 14 0" />
                      </svg>
                      &nbsp;{formattedTimeStart} - {formattedTimeEnd}
                    </span>
                  </p>

                  <div className="d-flex justify-content-center mb-5">
                    <button
                      type="button"
                      className="btn btn-secondary me-3"
                      onClick={handleCancel}
                    >
                      Cancel Appointment
                    </button>
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={handleReschedule}
                    >
                      Reschedule Appointment
                    </button>
                  </div>
                </>
              ) : (
                <p className="para-desc mx-auto text-muted">Loading...</p>
              )}
            </div>
          </div>
        </div>
        </div>
      </section>
    </>
  );
}

export default DetailsScreen;
